module.exports = __webpack_public_path__ + "img/curv_16_a.5640c1b4.jpg";